<section style="overflow-y: scroll;height: 390px;">

<div>
    <div class="wrapper">
    <div class="styled-input">
    <label class="diagnostic-label"  style="width: 90%;">Non Cancer Medical History</label>

    <button type="button" class="add-boutton" style="left: 83%;" name="Add" (click)="Save_MedicalHistory()">Update</button>
    </div>
    </div>
</div>
    <div class="appointment-form-field">
    <table style="width: 90%;">
      <tr>
        <td style="width: 35%;"><label style="width: 35%;"><input type="checkbox" [(ngModel)]= "diabetescheck" style="width: 20px;height: 20px;">Diabetes</label></td>
        <td style="width: 30%;"><label style="width: 10%;">Since <input type="number" [(ngModel)]= "diabetessince" style="width: 35%;border-style: none;font-size: large;"></label></td>
        <td style="width: 15%;">
          <select id="diabetesdays" name="diabetesdays" style="width: 100%;background-color:  rgb(235, 235, 235);border-style: none;font-size: large;" required [(ngModel)]= "diabetesdays">
            <option value="">Select*</option>
            <option value="Day">Day</option>
            <option value="Month">Month</option>
            <option value="Year">Year</option>
          </select></td>
      </tr>
      <tr>
        <td style="width: 35%;"><label style="width: 35%;;"><input type="checkbox" [(ngModel)]="haypercheck" style="width: 20px;height: 20px;">Hypertension</label></td>
        <td style="width: 30%;"><label style="width: 10%;" >Since <input type="number" [(ngModel)]= "haypersince" style="width: 35%;border-style: none;font-size: large;"></label></td>
        <td style="width: 15%;"><select id="hayperdays" name="hayperdays" style="width: 100%;background-color:  rgb(235, 235, 235);border-style: none;font-size: large;" required [(ngModel)]= "hayperdays">
          <option value="">Select*</option>
          <option value="Day">Day</option>
          <option value="Month">Month</option>
          <option value="Year">Year</option>
        </select>
      </td>
      </tr>
      <tr>
        <td style="width: 35%;"><label style="width: 35%;; "><input type="checkbox" [(ngModel)]="hepacheck" style="width: 20px;height: 20px;">Hepatitis C</label></td>
        <td style="width: 30%;"><label style="width: 10%;" >Since <input type="number" [(ngModel)]= "hepasince" style="width: 35%;border-style: none;font-size: large;"></label></td>
        <td style="width: 15%;"><select id="hepadays" name="hepadays" style="width: 100%;background-color:  rgb(235, 235, 235);border-style: none;font-size: large;" required [(ngModel)]= "hepadays">
          <option value="">Select*</option>
          <option value="Day">Day</option>
          <option value="Month">Month</option>
          <option value="Year">Year</option>
        </select>
      </td>
      </tr>
      <tr>
        <td style="width: 35%;"><label style="width: 35%;;  "><input type="checkbox" [(ngModel)]="bilhcheck" style="width: 20px;height: 20px;">Ischemic heart</label></td>
        <td style="width: 30%;"><label style="width: 10%;" >Since <input type="number" [(ngModel)]= "bilhsince" style="width: 35%;border-style: none;font-size: large;"></label></td>
        <td style="width: 15%;">
          <select id="bilhdays" name="bilhdays" style="width: 100%;background-color:  rgb(235, 235, 235);border-style: none;font-size: large;" required [(ngModel)]= "bilhdays">
          <option value="">Select*</option>
          <option value="Day">Day</option>
          <option value="Month">Month</option>
          <option value="Year">Year</option>
         </select>
        </td>
      </tr>
      <tr>
        <td style="width: 35%;"><label style="width: 35%; "><input type="checkbox" [(ngModel)]="cardcheck" style="width: 20px;height: 20px;">Cardiomyopathy</label></td>
        <td style="width: 30%;"><label style="width: 10%;" >Since <input type="number" [(ngModel)]= "cardsince" style="width: 35%;border-style: none;font-size: large;"></label></td>
        <td style="width: 15%;">
          <select id="carddays" name="carddays" style="width: 100%;background-color:  rgb(235, 235, 235);border-style: none;font-size: large;" required [(ngModel)]= "carddays">
            <option value="">Select*</option>
            <option value="Day">Day</option>
            <option value="Month">Month</option>
            <option value="Year">Year</option>
           </select>
          </td>
      </tr>

      <tr>
        <td style="width: 35%;"><label style="width: 35%; ">
          <input type="checkbox" [(ngModel)]= "othersMcheck" style="width: 20px;height: 20px;">Others</label>
        </td>
        <td style="width: 30%;" colspan ="2">
          <textarea rows = "4" cols = "30" name = "otherscontrol" [(ngModel)]= "otherscontrol" class="appointment-form-field" style="width: 100%;height: 200%;" > Enter details here... </textarea><br>
        </td>

    </table>
  </div>



</section>


